import React, { Component } from "react";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import AddGlobalCatalogue from "./AddGlobalCatalogue";

export const SuperAdminAddGlobalCatalogue = () => {
  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row superadmin-pending-chains-vendor">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <AddGlobalCatalogue />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default SuperAdminAddGlobalCatalogue;
